import {
  AppliedOnType,
  CommissionType,
  InvoicingDateType,
  InvoicingPaymentType,
  ShortTermDefType
} from '../types';

export const partnerCommunityFAQs = [
  {
    title: 'Can I update my community listing?',
    description:
      'Yes, in order to make edits to your listing you will need to create a provider login. Seniorly gives community representatives access to manage their own listings, where they can update pricing, photos, and other information.'
  },
  {
    title: 'Can I get qualified resident prospects from Seniorly?',
    description:
      'You bet! Seniorly empowers families to browse online and self-select which communities they want to contact them. We also have the families complete online assessments which share qualification and matching data. Our Customer Success Team is also available to speak with families over the phone and sometimes live transfer them to you.'
  },
  {
    title:
      'What is a Partner Agent and why are they involved in the search process?',
    description:
      'Seniorly is partnered with over 200 Partner Agents (or local placement agents) across the US. Every prospect that requests information on Seniorly is paired with a Partner Agent to help them with the search process. The agent is there to help coordinate tours and support in the move in process once the family has decided on the right community. This takes away a lot of time spent by sales and marketing teams at the community trying to track down online leads.'
  },
  {
    title: 'Why is there a Partner Agent on my community listing?',
    description:
      'Simple. Showcasing our Partner Agents increases our prospect engagement and satisfaction. Partner Agents are readily available to answer family questions about local communities and make sure the properties they are requesting information about are a fit.'
  },
  {
    title: 'What is this going to cost me?',
    description:
      'You will pay Seniorly a placement fee upon successful resident move-ins. If Seniorly was working with a Partner Agent on that move, you will only pay one placement fee that is split between Seniorly and the Partner Agent.'
  }
];

export const imageOwnership = {
  unknown: 'Unknown',
  seniorly: 'Seniorly',
  community: 'Community',
  scraped: 'Scraped'
};

export const LicenseAllegations = 'allegations';
export const LicenseInspections = 'inspections';
export const LicenseAge = 'license age';
export const LicenseLatestInspection = 'latest inspection';
export const LicenseCitations = 'Type A citations';

export const upTo20Beds = 'up to 20 Beds';
export const from20To51Beds = '20 - 51 Beds';
export const from51Beds = '51 +';

export const communitySizes: { [key: string]: string } = {
  [upTo20Beds]: 'small',
  [from20To51Beds]: 'medium',
  [from51Beds]: 'large'
};

export const Provided = 'Provided';
export const SlyAI = 'SlyAI';
export const Estimated = 'Estimated';

export const YouTubeUrlRegex =
  /^https?\:\/\/(?:www\.youtube(?:\-nocookie)?\.com\/|m\.youtube\.com\/|youtube\.com\/)?(?:ytscreeningroom\?vi?=|youtu\.be\/|vi?\/|user\/.+\/u\/\w{1,2}\/|embed\/|watch\?(?:.*\&)?vi?=|\&vi?=|\?(?:.*\&)?vi?=)([^#\&\?\n\/<>"']*)/i;

export const VimeoUrlRegex = /https:\/\/vimeo\.com\/\d+(?:\/[0-9a-f]+)?/;

export const UnClaimedOrgNames = [
  'Seniorly OfflineProfiles',
  'Seniorly Admin Org'
];

export const COMMUNITY_FILTER_OPTIONS = [
  'city',
  'state',
  'contract-status',
  'address',
  'managementCompany',
  'slug',
  'care',
  'starting-rate',
  'size',
  'contact'
];

export const CONTACTS_FILTER_OPTIONS = ['email', 'phone'];

export const GET_COMMUNITY_INCLUDE_PARAMS = [
  'contacts',
  'twilioNumber',
  'entityAux',
  'user',
  'address',
  // gallery
  'gallery',
  'gallery.images',
  'gallery.images.category',
  'videoGallery.videos',
  // similar communities
  'similarCommunities',
  // similar
  'similarCommunities.similar',
  'similarCommunities.similar.gallery',
  'similarCommunities.similar.gallery.images',
  // recommended
  'similarCommunities.recommended',
  'similarCommunities.recommended.gallery',
  'similarCommunities.recommended.gallery.images',
  // luxury
  'similarCommunities.luxury',
  'similarCommunities.luxury.gallery',
  'similarCommunities.luxury.gallery.images',
  // independent
  'similarCommunities.independent',
  'similarCommunities.independent.gallery',
  'similarCommunities.independent.gallery.images',
  // partner agent
  'partnerAgents',
  'partnerAgents.communities',
  'partnerAgents.address',
  'partnerAgents.gallery',
  'partnerAgents.gallery.images',
  // entity agent
  'recommendedAgents',
  'questions',
  'slyPrices',
  'tags',
  'reviews',
  'reviews.responseRatings',
  'community-responses',
  'rgsAux',
  'socialProofData',
  'experiments',
  'partnerCollection',
  'externalCommunityInfo'
].join(',');

// IF YOU UPDATE THIS VALUE YOU MUST UPDATE THE VALUE IN THE API
// IN API - CommunityIncludeParams
export const GET_COMMUNITY_INCLUDE_PARAMS_ARR = [
  'contacts',
  'twilioNumber',
  'entityAux',
  'user',
  'address',
  // gallery
  'gallery',
  'gallery.images',
  'gallery.images.category',
  'videoGallery.videos',
  // similar communities
  'similarCommunities',
  // similar
  'similarCommunities.similar',
  'similarCommunities.similar.gallery',
  'similarCommunities.similar.gallery.images',
  // recommended
  'similarCommunities.recommended',
  'similarCommunities.recommended.gallery',
  'similarCommunities.recommended.gallery.images',
  // luxury
  'similarCommunities.luxury',
  'similarCommunities.luxury.gallery',
  'similarCommunities.luxury.gallery.images',
  // independent
  'similarCommunities.independent',
  'similarCommunities.independent.gallery',
  'similarCommunities.independent.gallery.images',
  // partner agent
  'partnerAgents',
  'partnerAgents.communities',
  'partnerAgents.address',
  'partnerAgents.gallery',
  'partnerAgents.gallery.images',
  // entity agent
  'recommendedAgents',
  'questions',
  'slyPrices',
  'tags',
  'reviews',
  'reviews.responseRatings',
  'community-responses',
  'rgsAux',
  'socialProofData',
  'experiments',
  'partnerCollection',
  'neighborhoodSurvey',
  'externalCommunityInfo',
  'organization'
];

export const COMMUNINITY_INCLUDE_PARAMS_STRING =
  'include=contacts&include=twilioNumber&include=entityAux&include=user&include=address&include=gallery&include=gallery.images&include=gallery.images.category&include=videoGallery.videos&include=similarCommunities&include=similarCommunities.similar&include=similarCommunities.similar.gallery&include=similarCommunities.similar.gallery.images&include=similarCommunities.recommended&include=similarCommunities.recommended.gallery&include=similarCommunities.recommended.gallery.images&include=similarCommunities.luxury&include=similarCommunities.luxury.gallery&include=similarCommunities.luxury.gallery.images&include=similarCommunities.independent&include=similarCommunities.independent.gallery&include=similarCommunities.independent.gallery.images&include=partnerAgents&include=partnerAgents.communities&include=partnerAgents.address&include=partnerAgents.gallery&include=partnerAgents.gallery.images&include=recommendedAgents&include=questions&include=slyPrices&include=tags&include=reviews&include=rgsAux&include=socialProofData&include=experiments&include=partnerCollection&include=neighborhoodSurvey&include=externalCommunityInfo&include=organization&include=reviews.responseRatings&include=community-responses';

export type CommissionTypeKey =
  | 'percentage'
  | 'percentageCustom'
  | 'flatRate'
  | 'flatRateCustom';

export const COMMUNITY_CONTRACT_COMMISSION_TYPES: Record<
  CommissionTypeKey,
  CommissionType
> = {
  percentage: 'Percentage',
  percentageCustom: 'Percentage Custom',
  flatRate: 'Flat Rate',
  flatRateCustom: 'Flat Rate Custom'
};

export const COMMUNITY_CONTRACT_COMMISSION_TYPES_OPTIONS = Object.entries(
  COMMUNITY_CONTRACT_COMMISSION_TYPES
).map(([_, value]) => ({
  value: value as CommissionType,
  label: value
}));

export type AppliedOnTypeKey =
  | 'rent'
  | 'rentAndCare'
  | 'rentAndCareAndRespite'
  | 'rentAndRespite'
  | 'Other';

export const COMMUNITY_CONTRACT_APPLIED_ON_TYPES: Record<
  AppliedOnTypeKey,
  AppliedOnType
> = {
  rent: 'rent',
  rentAndCare: 'rent and care',
  rentAndCareAndRespite: 'rent and care and respite',
  rentAndRespite: 'rent and respite',
  Other: 'Other'
};

export const COMMUNITY_CONTRACT_APPLIED_ON_TYPES_OPTIONS = Object.entries(
  COMMUNITY_CONTRACT_APPLIED_ON_TYPES
).map(([_, value]) => ({
  value: value as AppliedOnType,
  label: value
}));

export type InvoiceDateKey = 'Days_14' | 'Days_30' | 'Days_60' | 'Other';

export const COMMUNITY_CONTRACT_INVOICING_DATE_TYPES: Record<
  InvoiceDateKey,
  InvoicingDateType
> = {
  Days_14: '14 days following the move-in',
  Days_30: '30 days following the move-in',
  Days_60: '60 days following the move-in',
  Other: 'Other'
};

export const COMMUNITY_CONTRACT_INVOICE_DATE_OPTIONS = Object.entries(
  COMMUNITY_CONTRACT_INVOICING_DATE_TYPES
).map(([_, value]) => ({
  value: value as InvoicingDateType,
  label: value
}));

export type InvoicePaymentKey = 'Days_30' | 'Days_60' | 'Other';

export const COMMUNITY_CONTRACT_INVOICING_PAYMENT_TYPES: Record<
  InvoicePaymentKey,
  InvoicingPaymentType
> = {
  Days_30: '30 days',
  Days_60: '60 days',
  Other: 'Other'
};

export const COMMUNITY_CONTRACT_INVOICE_PAYMENT_OPTIONS = Object.entries(
  COMMUNITY_CONTRACT_INVOICING_PAYMENT_TYPES
).map(([_, value]) => ({
  value: value as InvoicingPaymentType,
  label: value
}));

export type ShortTermDefKey = 'Days_30' | 'Days_60';

export const COMMUNITY_CONTRACT_SHORT_TERM_DEF_TYPES: Record<
  ShortTermDefKey,
  ShortTermDefType
> = {
  Days_30: '30 cumulative days',
  Days_60: '60 cumulative days'
};

export const COMMUNITY_CONTRACT_SHORT_TERM_DEF_OPTIONS = Object.entries(
  COMMUNITY_CONTRACT_SHORT_TERM_DEF_TYPES
).map(([_, value]) => ({
  value: value as ShortTermDefType,
  label: value
}));

export const COMMUNITY_CONTRACT_SHORT_TERM_RATE_OPTIONS = Array.from(
  { length: 100 },
  (_, i) => {
    const value = i + 1;
    return {
      label: `${value}%`,
      value: `${value}%`
    };
  }
);

export const COMMUNITY_CONTRACT_SAVE_KEY = 'community-contract';

export const AGENT_COMMUNITY_CONTRACT_PENDING_STATUS = 'Pending';
export const AGENT_COMMUNITY_CONTRACT_APPROVED_STATUS = 'Approved';

export const CRITICAL_TERMS_LABEL_VALUES: Record<string, string> = {
  commissionType: 'Commission type',
  commissionPercentage: 'Commission percentage (Rate)',
  commissionPercentageCustom: 'Commission percentage (Rate)',
  flatRate: 'Flat Rate (Rate)',
  flatRateCustom: 'Flat Rate (Rate)',
  percentagePaymentTerms: 'Payment terms',
  appliedOn: 'Applied on',
  invoicingDate: 'Invoicing date',
  invoicingPayment: 'Invoicing payment',
  shortTermRate: 'Short term rate',
  shortTermMoveDefinition: 'Short-term move definition',
  stateJurisdiction: 'State jurisdiction',
  countyJurisdiction: 'Critical Terms Defaults',
  contactTitle: 'County jurisdiction',
  flatPaymentTerms: 'Flat payment terms'
};

export const ONE_TIME_COMMUNITY_CONTRACT = 'One Time Contract';
export const BULK_COMMUNITY_CONTRACT = 'Bulk Contract';
